import { render, staticRenderFns } from "./TestView123.vue?vue&type=template&id=339419c0&scoped=true"
import script from "./TestView123.vue?vue&type=script&lang=js"
export * from "./TestView123.vue?vue&type=script&lang=js"
import style0 from "./TestView123.vue?vue&type=style&index=0&id=339419c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339419c0",
  null
  
)

export default component.exports